
export const FETCH_CLIENTS = 'FETCH_CLIENTS'
export const FETCH_CLIENTS_META = 'FETCH_CLIENTS_META'
export const FETCH_CLIENT = 'FETCH_CLIENT'
export const ADD_CLIENT = 'ADD_CLIENT'
export const CREATE_CLIENT = 'CREATE_CLIENT'
export const DELETE_CLIENT = 'DELETE_CLIENT'
export const EDIT_CLIENT = 'EDIT_CLIENT'
export const FETCH_CLIENT_ORDERS = 'FETCH_CLIENT_ORDERS'
export const FETCH_CLIENT_ORDERS_OLD = 'FETCH_CLIENT_ORDERS_OLD'
export const FETCH_CLIENT_ORDERS_META = 'FETCH_CLIENT_ORDERS_META'
export const FETCH_CLIENT_ORDERS_PRODUCTS = 'FETCH_CLIENT_ORDERS_PRODUCTS'
export const FETCH_CLIENT_ORDERS_PRODUCTS_META = 'FETCH_CLIENT_ORDERS_PRODUCTS_META'
export const EDIT_AVATAR = 'EDIT_AVATAR' //deprecated
export const FETCH_CLIENTS_SEARCH_SUGGESTIONS = 'FETCH_CLIENTS_SEARCH_SUGGESTIONS'
export const FETCH_CLIENT_STATISTICS = 'FETCH_CLIENT_STATISTICS'
export const FETCH_CLIENTS_STATISTICS = 'FETCH_CLIENTS_STATISTICS'
export const FETCH_CREDIT_LOGS = 'FETCH_CREDIT_LOGS'
export const DEPOSIT_CLIENT = 'DEPOSIT_CLIENT'
